import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, Link } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import axios from 'axios'
import im from '../../images/loginimage.jpg'
import loader from '../../images/load.gif'
import { setdata, setisLoggedin } from '../../redux/reducers/userSlice'
import styles from './../../styles/login.module.css'

const notify = (message, type = 'success') =>
  toast[type](message, { position: 'bottom-right', theme: 'colored' })

function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const validate = () => {
    if (!email) {
      notify('Please enter your email', 'error')
      return false
    }
    if (!password) {
      notify('Please enter your password', 'error')
      return false
    }
    return true
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!validate()) return

    try {
      setLoading(true)
      const res = await axios.post('https://chatting-club-backend.onrender.com/api/users/login', { email, password })
      setLoading(false)

      if (res.data.success) {
        const resProf = await axios.get('https://chatting-club-backend.onrender.com/api/users/profile', {
          withCredentials: true
        })
        dispatch(setisLoggedin(true))
        dispatch(setdata(resProf.data.user))
        notify('Welcome back! 🎉', 'success')
        navigate('/')
      } else {
        notify(res.data.message || 'Login failed', 'error')
      }
    } catch (err) {
      setLoading(false)
      const errorMessage = err.response?.data?.message || 'Something went wrong. Please try again.'
      notify(errorMessage, 'error')
    }
  }

  const handleGoogleLogin = () => {
    window.location.href = 'https://chatting-club-backend.onrender.com/auth/callback'
  }

  return (
    <>
      <div className={styles.loginPage}>
        <main className={styles.login}>
          <section className={styles.card}>
            <aside className={styles.visualPanel}>
              <img src={im} className={styles.visualImage} alt="Chat interface" />
              <div className={styles.visualOverlay} />
              
              <div className={styles.visualContent}>
                <span className={styles.badge}>💬 Live Chat</span>
                <h1>
                  Connect with
                  <br />
                  your community
                </h1>
                <p>Real-time messaging, instant connections, and meaningful conversations—all in one place.</p>
                
                <div className={styles.benefits}>
                  <span>⚡ Real-time messaging</span>
                  <span>🔒 End-to-end encrypted</span>
                  <span>🌐 Connect globally</span>
                </div>
              </div>
            </aside>

            <section className={styles.formPanel}>
              <div className={styles.formWrapper}>
                <div className={styles.heading}>
                  <span className={styles.eyebrow}>Welcome back</span>
                  <h2>Log in to Chat</h2>
                  <p>Continue your conversations where you left off.</p>
                </div>

                <form className={styles.form} onSubmit={handleSubmit}>
                  <div className={styles.field}>
                    <label htmlFor="email">Email address</label>
                    <input
                      id="email"
                      type="text"
                      value={email}
                      autoComplete="off"
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="you@example.com"
                      disabled={loading}
                    />
                  </div>

                  <div className={styles.field}>
                    <label htmlFor="password">Password</label>
                    <input
                      id="password"
                      type="password"
                      value={password}
                      autoComplete="off"
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter your password"
                      disabled={loading}
                    />
                  </div>

                  <div className={styles.optionsRow}>
                    <label className={styles.rememberMe}>
                      <input type="checkbox" />
                      Remember me
                    </label>
                    <Link to="/forgot-password" className={styles.link}>
                      Forgot password?
                    </Link>
                  </div>

                  <button type="submit" className={styles.submit} disabled={loading}>
                    {loading ? (
                      <>
                        <span className={styles.spinner} />
                        Logging in...
                      </>
                    ) : (
                      'Log in'
                    )}
                  </button>
                </form>

                <div className={styles.divider}>
                  <span>or continue with</span>
                </div>

                <button 
                  className={styles.googleButton} 
                  onClick={handleGoogleLogin}
                  disabled={loading}
                >
                  <svg className={styles.googleIcon} viewBox="0 0 48 48">
                    <path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" />
                    <path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" />
                    <path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" />
                    <path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z" />
                  </svg>
                  Continue with Google
                </button>

                <p className={styles.footer}>
                  New to Chat? <Link to="/register">Create an account</Link>
                </p>
              </div>
            </section>
          </section>
        </main>
      </div>
    </>
  )
}

export default Login